export const Feedback = '//form.asana.com/?k=HOb2iQqhGUeSG1lj_PjIKQ&d=523429734671116' as const;
export const Support = '//support.hologram.io/hc/en-us' as const;
export const NewSupportTicket = '//support.hologram.io/hc/en-us/requests/new' as const;
export const SimulateDataRouterArticle =
  '//support.hologram.io/hc/en-us/articles/360049369994-Simulate-Data-Router-messages-from-a-device&utm_medium=application&utm_content=simulate_message_to_api' as const;
export const ManageDeviceTunnelingArticle =
  '//support.hologram.io/hc/en-us/articles/360045634694-Establish-a-secure-Spacebridge-tunnel-to-a-device-using-ssh' as const;
export const SetUsageAlertsArticle =
  '//support.hologram.io/hc/en-us/articles/360042755573-Hologram-Inflight-Enterprise' as const;
export const FPLMNArticle =
  '//support.hologram.io/hc/en-us/articles/360035697373-Clear-the-FPLMN-forbidden-networks-list' as const;
